import { ORGANISATION_CODE, ORGANISATION_URL } from "./constants";
import styles from "./styles.module.scss";

interface Props {
  organization: any;
}

const OrganizationInfo = ({ organization }: Props) => {
  return (
    <div className={styles["card"]}>
      <div className={styles["organizationInfo"]}>
        <img
          src={organization.logoUrl}
          alt="organization logo"
          className={styles["img"]}
        />
        <div className={styles["organizationInfo-content"]}>
          <p className={styles["organizationInfo-content-name"]}>
            {organization.name}
          </p>
          <p className={styles["organizationInfo-content-description"]}>
            {organization.description}
          </p>
        </div>
        <div className={styles["organizationInfo-content-additional"]}>
          <div className={styles["additional-item"]}>
            <p className={styles["additional-item-title"]}>
              {ORGANISATION_CODE}
            </p>
            <p className={styles["additional-item-description"]}>
              {organization.code}
            </p>
          </div>
          <div className={styles["vertical-line"]}></div>
          <div className={styles["additional-item"]}>
            <p className={styles["additional-item-title"]}>
              {ORGANISATION_URL}
            </p>
            <a
              href={organization.websiteUrl}
              target="_blank"
              rel="noopener noreferrer"
              className={styles["additional-item-description"]}
              style={{ direction: "ltr" }}>
              {organization.websiteUrl}
            </a>
          </div>
        </div>
      </div>
    </div>
  );
};

export default OrganizationInfo;
